var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portlet"},[_c('div',{staticClass:"portlet-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-list',{attrs:{"c-conf":_vm.getHasmanyConf()}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }